import { CategoryType, FeatureButtonConfig } from 'components/Category/types';
import { MenuItemType, OverviewMenuItem } from 'types';

export const hasPermission = (permission: string | undefined, userPermissions: readonly string[]) => {
  if (!permission) return true;

  if (userPermissions.includes(permission)) return true;

  return false;
};
export const filterMenuByPermission = (menus: MenuItemType[], permissions: readonly string[]): MenuItemType[] =>
  menus
    .filter((m) => hasPermission(m.permission, permissions))
    .map((m) => ({
      ...m,
      children: m.children ? filterMenuByPermission(m.children, permissions) : undefined,
    }))
    .filter((m) => !m.children || m.children.length > 0);
export const filterOverviewMenuByPermission = (
  menus: OverviewMenuItem[],
  permissions: readonly string[],
): OverviewMenuItem[] => menus.filter((m) => hasPermission(m.permission, permissions));
export const filterHomeModuleByPermission = (
  menus: FeatureButtonConfig[],
  permissions: readonly string[],
): FeatureButtonConfig[] => menus.filter((m) => hasPermission(m.permission, permissions));
export const filterModuleByPermission = (menus: CategoryType[], permissions: readonly string[]): CategoryType[] =>
  menus.filter((m) => hasPermission(m.permission, permissions));
